<div fxFlexLayout fxLayoutAlign="space-between center">
	<h1 class="mat-display-1 pb-2 m-0 component-header">
		{{ headerText }}
	</h1>
	<mat-button-toggle-group>
		<mat-button-toggle
			[routerLink]="usersFragments.registrationRequestList"
			routerLinkActive="active-button"
			>Portal Registration Requests</mat-button-toggle
		>
		<mat-button-toggle
			[routerLink]="usersFragments.customerUserList"
			routerLinkActive="active-button"
			>Customer Portal Users</mat-button-toggle
		>
		<mat-button-toggle
			[routerLink]="usersFragments.adminUserList"
			routerLinkActive="active-button"
			>RAILS Users</mat-button-toggle
		>
	</mat-button-toggle-group>
</div>
